import * as React from 'react';
import FormControl from '../../Form/FormControl';
import Glycaemia, { GlycaemiaValues } from './Glycaemia';

interface Props {
	onChange?: (values: any) => void;
	value?: any;
	disabled?: boolean;
}

interface GlycaemiaFormControlProps extends Props {
	name: string;
	label?: string;
}

const GlycaemiaWrapper: React.FC<Props> = ({ onChange, value, disabled }) => {
	const handleChange = (values: GlycaemiaValues) => {
		onChange?.(values?.value);
	};

	return (
		<Glycaemia onChange={handleChange} value={value} disabled={disabled} />
	);
};

const GlycaemiaFormControl: React.FC<GlycaemiaFormControlProps> = props => {
	const { name, label, disabled, onChange, value } = props;

	return (
		<FormControl name={name} label={label}>
			<GlycaemiaWrapper disabled={disabled} onChange={onChange} value={value} />
		</FormControl>
	);
};

export default GlycaemiaFormControl;
